<!--
 * @Description: 老师分类 -- PC端
 * @Author: xiuwen
 * @Date: 2024-12-27 10:09:52
 * @LastEditors: 思齐
 * @LastEditTime: 2025-11-04 16:32:04
-->
<template>
	<section class="m-card">
		<h2 class="m-card-title">主題分類</h2>
		<div class="tab">
			<div
				class="tab-item"
				v-for="item in category"
				:class="{ active: item.value === active }"
				:key="item.value"
				@click="
					() => {
						if (loading) return;
						active = item.value;
						logEvent(`Online_Classification_click`);
					}
				"
			>
				<span>{{ item.label }}</span>
			</div>
		</div>

		<n-spin :show="loading && page === 1">
			<ul class="cs-list">
				<li v-for="item in data" :key="item.id" @click="jump(item.index_uri)">
					<div class="cs-icon">
						<img :src="item.icon" alt="" />
					</div>
					<p class="cs-title">{{ item.title }}</p>
					<p class="desc">{{ item.description }}</p>
				</li>
			</ul>
		</n-spin>

		<div class="load">
			<van-loading v-if="loading && page !== 1" color="#666666" />
			<div class="load-text" v-else>
				<div
					class="load-btn"
					v-if="!isFinish"
					@click="
						() => {
							page += 1;
							getList();
						}
					"
				>
					<span>加載更多</span>
					<i class="load-arrow">></i>
				</div>
				<div class="no-more" v-else>
					<span>沒有更多了~</span>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import { getCategoryList, getCategoryProduct } from "~/api/api";
import { computed, ref, watch } from "vue";
import { goLink } from "~/utils/common";

const active = ref(0);
const category = ref([]);
getCategoryList().then(res => {
	category.value = Object.keys(res.data).map(key => {
		return {
			label: res.data[key],
			value: key,
		};
	});
	active.value = category.value[0].value;
	getList();
});

const page = ref(1);
const size = ref(8);
const total = ref(0);
const data = ref([]);
const isFinish = computed(() => data.value.length >= total.value);
const loading = ref(false);
const jump = url => {
	logEvent(`Online_Classification_click`);
	goLink(url, "calc-categories-m");
};

const getList = () => {
	if (loading.value) return;
	loading.value = true;
	getCategoryProduct({
		category_id: active.value,
		page: page.value,
		size: size.value,
	})
		.then(res => {
			const list = res.data.list.map(item => {
				return {
					...item,
					name: item.title,
					cover: item.icon,
					jump_url: item.index_uri,
				};
			});

			if (page.value === 1) {
				data.value = list;
			} else {
				data.value = [...data.value, ...list];
			}

			total.value = res.data.pager.total_count;
			loading.value = false;
		})
		.catch(() => {
			page.value -= 1;
			loading.value = false;
		});
};

watch(
	() => active.value,
	() => {
		page.value = 1;
		getList();
	}
);

const events = [
	{
		tab: "bazixiangpi",
		event: "site_calc_bazi_click",
	},
	{
		tab: "danrenyinyuan",
		event: "site_calc_single_click",
	},
	{
		tab: "english",
		event: "site_calc_english_click",
	},
	{
		tab: "other",
		event: "site_calc_more_click",
	},
	{
		tab: "shiye",
		event: "site_calc_work_click",
	},
	{
		tab: "tarot",
		event: "site_calc_tarot_click",
	},
	{
		tab: "shuangrenyinyuan",
		event: "site_calc_couple_click",
	},
	{
		tab: "zonghe",
		event: "site_calc_ziwei_click",
	},
];

const findEventByProduct = str => {
	for (const event of events) {
		if (str.includes(event.tab)) {
			return event.event;
		}
	}
	return null;
};

watch(
	() => active.value,
	() => {
		const event = findEventByProduct(active.value);
		event && logEvent(event);
	}
);
</script>

<style lang="scss" scoped>
.m-card {
	margin-top: 48px;
	padding: 0 24px;
	font-family: PingFang SC;
	box-sizing: border-box;

	.m-card-title {
		font-weight: 600;
		font-size: 36px;
		color: #333333;
		line-height: 60px;
	}

	.tab {
		margin: 20px 0 0;
		display: flex;
		flex-wrap: nowrap;
		gap: 12px;
		font-family: PingFang SC;
		user-select: none;
		overflow-x: auto;
		overflow-y: hidden;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		.tab-item {
			min-width: 132px;
			height: 60px;
			padding: 15px 22px;
			flex: 0 0 auto;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			font-weight: 600;
			font-size: 26px;
			color: #a0a0a0;
			line-height: 38px;
			white-space: nowrap;
			background: #f9f8f6;
			border: 2px solid transparent;
			border-radius: 10px;
			cursor: pointer;
			box-sizing: border-box;
			transition: all 0.2s ease;
		}

		.active {
			color: #333333;
			background: #ffffff;
			border-color: #333333;
		}
	}

	.cs-list {
		margin-top: 20px;
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 16px;

		li {
			padding: 12px;
			background: #ffffff;
			border: 2px solid #ececec;
			border-radius: 12px;
			box-sizing: border-box;
			cursor: pointer;

			.cs-icon {
				width: 100%;
				aspect-ratio: 1 / 1;
				border-radius: 10px;
				overflow: hidden;
				background: #f4f4f4;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			.cs-title {
				margin-top: 10px;
				font-weight: 500;
				font-size: 30px;
				color: #333333;
				line-height: 50px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.desc {
				margin-top: 6px;
				font-weight: 400;
				font-size: 27px;
				color: #333;
				line-height: 44px;
				display: -webkit-box;
				line-clamp: 3;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 3;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}

	.load {
		margin-top: 40px;
		user-select: none;

		:deep(.van-loading) {
			text-align: center;
		}

		.load-text {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 24px;
			color: #666666;
			line-height: 33px;
			text-align: center;

			.no-more {
				color: #c9c9c9;
			}

			.load-btn {
				display: flex;
				align-items: center;
				justify-content: center;
				min-width: 200px;
				height: 70px;
				padding: 0 24px;
				background: #ffffff;
				border: 2px solid #ececec;
				border-radius: 12px;
				cursor: pointer;
				box-sizing: border-box;

				span {
					margin-right: 14px;
					font-size: 28px;
					color: #666;
					line-height: 1;
				}

				.load-arrow {
					font-style: normal;
					font-weight: 500;
					font-size: 40px;
					color: #999999;
					line-height: 1;
				}
			}
		}
	}

	:deep(.n-spin) {
		color: #666666;
	}
}
</style>
